import React, {useState, useRef, useEffect, useMemo} from 'react';
import {TextField} from "@material-ui/core";

const BlurChangeTextField = ({ onChange, validate, errorMsg, maxLength, label, disabled = false, ...props }: {
    onChange: (value: string) => void;
    maxLength?: number;
    label?: string;
    disabled?: boolean;
    errorMsg?: string;
    validate?: (value: string) => boolean;
    [key: string]: any
}) => {
    const [value, setValue] = useState(props.value || '');
    const prevValue = useRef(value);
    const [error, setError] = useState(false);

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    useEffect(() => {
        if (validate && !disabled) {
            setError(!validate(value));
        }
    }, [value, validate, disabled]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (maxLength && value.length > maxLength) {
            return;
        }
        setValue(e.target.value);
    };

    const handleBlur = () => {
        if (value !== prevValue.current && !error) {
            onChange(value);
            prevValue.current = value;
        }
    };

    const handleFocus = () => {
        prevValue.current = value;
    };

    const labelStyle = {
        color: 'rgba(10, 25, 35, 0.9)',
        fontSize: '13px',
        lineHeight: '15px'
    }

    return (
        <>
            <span style={{ ...labelStyle, ...(disabled && { color: 'rgba(10, 25, 35, 0.4)'}) }}>{label}</span>
            <TextField
                {...props}
                error={error}
                helperText={error ? 'Введите корректный номер телефона' : ''}
                disabled={disabled}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
            />
        </>
    );
};

export default BlurChangeTextField
